import { CreateItemActionCreatorOptions, resources } from 'redux-and-the-rest';

import { GameScoreModel } from '../../models/gameScoreModel';
import Env from '../../utils/env';
import { ISLANDS_PATH } from './islandReducer';
import { userActions } from './userReducer';

const {
  reducers: gameScoresReducer,
  fetchList: fetchGameScores,
  createItem: createGameScore,
  getOrFetchItem: getOrFetchGameScore,
  getOrFetchList: getOrFetchGameScores,
  updateItem: chooseGameScoreReward,
} = resources<GameScoreModel>(
  {
    name: 'gameScore',
    url: `${Env.API_URL}${ISLANDS_PATH}/:islandId/game_scores/:id?`,
    keyBy: 'id',
    clearOn: [
      userActions.clearItem as string,
    ],
  },
  {
    fetchList: true,
    createItem: true,
    fetchItem: true,
    updateItem: true,
  },
);

const INCLUDES = 'game,chosenReward,rewardsToChooseFrom';

const abstractedCreateGameScore = (
  { islandId }: { islandId: string },
  attributes: GameScoreModel,
  options?: CreateItemActionCreatorOptions<GameScoreModel>,
): void => {
  createGameScore(
    {
      include: INCLUDES,
      islandId,
    },
    {
      relationshipNames: ['game'],
      ...attributes,
    },
    {
      unshift: [{ islandId }],
      ...options,
    },
  );
};

export {
  gameScoresReducer,
  chooseGameScoreReward,
  abstractedCreateGameScore as createGameScore,
  fetchGameScores,
  getOrFetchGameScore,
  getOrFetchGameScores,
};
